import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import useTrackPage from 'hooks/useTrackPage';

export default function Flow({ component: InnerComponent, pageTitle }) {
  const baseClass = 'bsd-layout';
  useTrackPage(pageTitle);

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <div
      className={`${baseClass} ${baseClass}--flow bsd-content-focus`}
      id="content"
    >
      <div className="bsd-content container">
        <InnerComponent />
      </div>
    </div>
  );
}

Flow.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  pageTitle: PropTypes.string,
};

Flow.defaultProps = {
  pageTitle: null,
};
